module.exports = __webpack_public_path__ + "static/media/areamap4.6f2ae9e9.svg";